module.exports = __webpack_public_path__ + "static/media/diners.04c1ea2e.svg";